import { ClientEvent, MatrixClient, SyncState, createClient } from "matrix-js-sdk";
import { MATRIX_SERVER_URL } from "./constants";

export const createAndInitializeClient = async (
    matrixToken: string,
    userId: string
  ): Promise<MatrixClient | null> => {
    if (!matrixToken) return null;
    try {
      const client = createClient({
        baseUrl: MATRIX_SERVER_URL,
        userId: userId,
        accessToken: matrixToken
      });
  
      return new Promise((resolve, reject) => {
        if (
          !client.getSyncState() ||
          client.getSyncState() === SyncState.Stopped
        ) {
          client.startClient({initialSyncLimit: 30}).catch(reject);
        }
  
        client.once(ClientEvent.Sync, (state) => {
          if (state === 'PREPARED') {
            resolve(client);
          }
          reject(new Error(`Unexpected sync result on prepare: "${state}"`));
        });
      });
    } catch (error) {
      console.error('Failed to initialize the Matrix client', error);
      throw error;
    }
  };
  